import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllSzGrpDtls,
  fetchOneSzGrpDtl,
  createSzGrpDtl,
  updateSzGrpDtl,
  deleteSzGrpDtl,
  fetchColumnOrderSizeColumns,
} from "services/szgrpdtl";

// Hook for fetching column order size columns
export const useColumnOrderSizeColumns = () => {
  const query = useQuery({
    queryKey: ["column-order-size-columns"],
    queryFn: () => fetchColumnOrderSizeColumns(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
  return query;
};

// Hook for fetching all size group details
export const useAllSzGrpDtls = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-szgrpdtls", filters],
    queryFn: () => fetchAllSzGrpDtls(filters),
  });
  return query;
};

// Hook for fetching one size group detail
export const useOneSzGrpDtl = (id, enabled = true) => {
  const query = useQuery({
    queryKey: ["one-szgrpdtl", id],
    queryFn: () => {
      if (id) {
        return fetchOneSzGrpDtl(id);
      }
    },
    enabled,
  });
  return query;
};

// Hook for creating size group detail
export const useCreateSzGrpDtl = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: (data) => createSzGrpDtl(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-szgrpdtls"] });
      queryClient.invalidateQueries({ queryKey: ["column-order-size-columns"] });
    },
  });
  return query;
};

// Hook for updating size group detail
export const useUpdateSzGrpDtl = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: ({ id, data }) => updateSzGrpDtl({ id, data }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-szgrpdtls"] });
      queryClient.invalidateQueries({ queryKey: ["one-szgrpdtl", variables.id] });
      queryClient.invalidateQueries({ queryKey: ["column-order-size-columns"] });
    },
  });
  return query;
};

// Hook for deleting size group detail
export const useDeleteSzGrpDtl = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: (id) => deleteSzGrpDtl(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["all-szgrpdtls"] });
      queryClient.invalidateQueries({ queryKey: ["one-szgrpdtl", id] });
      queryClient.invalidateQueries({ queryKey: ["column-order-size-columns"] });
    },
  });
  return query;
}; 